/**
 * Тексти порожніх станів (UX-37; states.md, розд. 1). Лише для лінивих чанків екранів, тож не
 * входить у зведений `uk.ts`. Назв сутностей тут немає: форми слова дають метадані (`noun()`),
 * функції лише підставляють їх.
 */
export const empty = {
  /** Записи без підпису сутності: метаданих ще немає або сутність без форм слова. */
  emptyRecords: 'записи',
  emptyNone: (plural: string) => `Тут з’являться ${plural}`,
  emptyNoneOwn: (plural: string) => `Тут з’являться ваші ${plural}`,
  emptyAssigned: 'Вони з’являться, коли їх призначать вам',
  emptyByColleagues: 'Вони з’являться, коли їх створять колеги',
  emptyFiltered: (genitivePlural: string) => `Немає ${genitivePlural} за цими фільтрами`,
  emptyFilters: 'Фільтри',
  emptyResetFilters: 'Скинути фільтри',
  emptySearch: (query: string) => `Нічого не знайдено за «${query}»`,
  emptyDone: 'Усе зроблено',
} as const;
